import {NgModule} from '@angular/core';
import {MaterialModule} from '../material/material.module';
import {RegionService} from './services/region/region.service';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {UtilitiesModule} from '../utilities/utilities.module';
import { RegionEditComponent } from './component/region-edit/region-edit.component';
import { RegionsComponent } from './component/regions/regions.component';
import {ReportModule} from '../report/report.module';
import {RegionResolverService} from './resolvers/region-resolver.service';


@NgModule({
  declarations: [
    RegionEditComponent,
    RegionsComponent
  ],
  imports: [
    MaterialModule,
    CommonModule,
    FormsModule,
    UtilitiesModule,
    ReportModule
  ],
  exports: [
  ],
  providers: [
    RegionService,
    RegionResolverService
  ]
})
export class RegionModule { }



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/region/region.module.ts